import {React, useEffect} from "react";
import HeroHeader from "./HeroHeader";
import ContactCTA from "./ContactCTA";
import ButtonLink from "./ButtonLink";
import { Helmet } from "react-helmet";
import EverestTestWebgGL from "../img/everest_webgl_test.gif";
import GeorgePersona from "../img/George persona.png";
import CarlyPersona from "../img/Carly persona.png";
import EverestSketches from "../img/everest_sketches.PNG";
import Storyboard from "../img/everest storyboard.png";
import IA from "../img/everest_IA.png";
import Palette from "../img/Palette.svg";
import Matcap from "../img/toon matcap.png";
import HACE from "../img/HACE.png";
import HAPE from "../img/HAPE.png";
import Demo1 from "../img/everest_scroll.gif";
import Demo2 from "../img/everest_scroll 2.gif";
import Demo3 from "../img/everest_scroll 3.gif";
import TimeToTask from "../img/timetotask.png";
import TaskSuccess from "../img/tasksuccessrate.PNG";


import EverestMockup from "../img/everest_mockup.png";

function DeathZone() {

  // useEffect(() => {
  //   document.title = "ETCHNG | Data storytelling of high-altitude physiology on Mt. Everest";  
  
  // }, []);  

  return (
    <>
    <Helmet>
        <title>ETCHNG | Data storytelling of high-altitude physiology on Mt. Everest</title>
        <meta name="description" content="Death zone scrolling data visualization"/> 
        <meta name="keywords" content="ETCHNG, medical illustrator, Eric Chung, Mt Everest, death zone, animation, UI/UX"
        />
    </Helmet>
      <HeroHeader
        hero_img={EverestMockup}
        type="Print spread —"
        name="Data storytelling of high-altitude physiology on Mt. Everest"
      />

      <div className="wrapper">
        <div className="wrapper__inner">
          <div className="work">
            <div className="work__info twoColumn">
              <div className="work__info__basic">
              <div className='work__info__basic__item'> <h5>Date</h5>
                  <p>Feb 2021 - Apr 2021 </p> </div>
                  <div className='work__info__basic__item'>    <h5>Role</h5>
                  <p>Illustrator, UI/UX designer, web developer</p></div>
                  <div className='work__info__basic__item'> <h5>Tools</h5>
                  <p>HTML/CSS/JS (Three.JS), ZBrush</p></div>
              </div>
            </div>

            <div className="work__info twoColumn">
              <h4>INTRODUCTION</h4>
              <p>The death zone refers to altitudes at which the pressure of oxygen is insufficient to sustain
              human life for an extended time span. This threshold is generally considered to be 8000 m.
              Many deaths in high-altitude mountaineering have been from the effects of the death zone,
              either directly via physiological decline or indirectly through how it impacts cognitive and
              physical capabilities.</p>

              <div className="btn__wrap">
                <a href="https://etchng.github.io/everest/" target="_blank">
                  <ButtonLink> View Demo</ButtonLink>
                </a>
              </div>
            </div>

            
          </div>
          <div className="work">
              <div className="work__info twoColumn">
                <h4>CHALLENGE</h4>
              </div>
              <div className="work__info twoColumn">
              <p>
              Trying to convey large volumes of technical, physiological information over an extended narrative in a
              single interface can easily overwhelm the user, and cause them to lose interest.
              In the context of geographical data storytelling, this can create <b>both spatial and temporal
                challenges</b>, in which the relationship between physiological events and geographic locations can be
              muddled.

            </p>

            <p>
              This scrollytelling data visualization was framed as if the client were an agency such as the New York
              Times or National Geographic, and they were looking for a science engagement Web experience to support a
              story, and help drive user engagement. It is intended to communicate the physiological challenges
              encountered
              when climbing Mt. Everest. </p>
            <p>
              WebGL elements were handled with the
              Three.JS library, while animations and transitions used GSAP and the Intersection Observer API.
            </p>

              </div>
            </div>

            <div className="work">
          <div className="work__info twoColumn">
            <h4>IDEATION</h4>


          </div>

        </div>
        <div className="work">

          <div className="work__info narrowColumn">

            <p>
              In my early landscape analysis, I gathered inspiration from various forms of media that were focused on
              creating engaging educational experience, while also conveying complex data. This included other
              scrollytelling sites, static print infographics, dashboards, and video games.

            </p>
            <p>
              I then started sketching ideas of a potential interface and features. Early concepts experimented with a
              WebXR-type experience, both with the A-frame and Three.js libraries, where users would interact with
              hotspots with freelook gaze-based interaction. To get a better sense of scale, including basic orbit
              controls were important.

            </p>


          </div>
          <div className="work__info wideColumn">
            <img src={EverestSketches} loading="lazy"
              alt="Early sketches of potential interfaces and features."></img>


          </div>

        </div>




        <div className="work">
          <p>
            I also created brief personas based on my proposed target users.

          </p> </div> <div className="work">
          <div className="work__info twoColumn">

          <img src={GeorgePersona} loading="lazy"
            alt="Primary persona of Curious George. Personality and characteristics include: Technology savvy and regularly likes to track analytics, 	Likes to dive deep into information, and Outdoors and fitness enthusiast."></img>
                   
          
         </div><div className="work__info twoColumn">

          <img src={CarlyPersona} loading="lazy"
            alt="Secondary persona of Casual Carly. Personality and characteristics include: comfortable with technology, limited science background, and likes a good story."></img>
        </div>
        </div></div> 
        

        <div className="work">

          <div className="work__info narrowColumn">
            <h4>PROTOTYPING</h4>

            <p>
              These sketches were then translated into wireframes.
              As this web app was based on a limited set on interactions in 3D space, I also coded out prototypes to
              test them with users. I quickly learned that combining all these interaction modalities created too much
              complexity and a disorienting experience. It made it particularly difficult to read text and data; I thus
              reverted to a simply scroll-based interaction.

            </p>
          </div>

          <div className="work__info wideColumn">

            <img src={EverestTestWebgGL} loading="lazy" alt="Test of freelook camera movement."></img>


          </div>

        </div>

        

        <div className="work">

          <div className="work__info wideColumn">
            <img src={Storyboard} loading="lazy"
              alt="Storyboard of the scrollytelling experience."></img>

          </div>
          <div className="work__info narrowColumn">
            <p>
              Early feedback also indicated that users preferred altitude-specific information about symptions to be
              located with the camp hotspots, instead of with the altitude sidebar. I also learned that explanations of
              the physiology would be improved with illustrations.

            </p>


          </div>



        </div>

     
        
        <div className="work">



          <div className="work__info narrowColumn">
            <h4>DESIGN</h4>



          </div>
        </div>
        <div className="work">
          <div className="work__info twoColumn">

            <div className="work__info">
              <p>At this point, I mapped out the information architecture more thoroughly. I also established a style
                guide to determine the aesthetic, and to begin asset development.</p>
              <img src={Palette} loading="lazy" alt="Storyboard of the scrollytelling experience."></img>

            </div>
          </div>
          <div className="work__info twoColumn">

            <div className="work__info">
              <img src={IA} loading="lazy"
                alt="Storyboard of the scrollytelling experience."></img>

            </div>
          </div>


        </div>

        <div className="work">
          <div className="work__info narrowColumn">

            <div className="work__info">
              <p>Terrain data was extracted using GIS software. To make it more performant, I transferred the detail
                from the high-poly model to a low-poly model via a normal map in ZBrush.
              </p>
              <p>
                However, due to the low image texture resolution, and proximity of the camera required, I opted for a
                more stylized approach for the overall aesthetic. To get around the limitations of native materials in
                Three.JS, and the challenges of writing GLSL, I created a matcap to simulate a tri-colour toon shader.
              </p>

              <p>Illustrations were done as SVGs to make scroll-driven animation of individual sub-elements easier and
                improve performance. </p>

              <img src={Matcap} loading="lazy" alt="Matcap used for the mountain toon shader"></img>
            </div>
          </div>
          <div className="work__info wideColumn">

            <div className="work__info">



              <img src={HACE} loading="lazy" alt="Ilustration of HACE with inset."></img>

            </div>
            <img src={HAPE} loading="lazy" alt="Ilustration of HAPE with inset."></img>
          </div>
        </div>

        <div className="work">

          <div className="work__info narrowColumn">
            <p>
              The user is be able to advance with the narrative by scrolling and look around with the cursor. This first-person perspective, combined with the 3D environment is
              intended to facilitate exploration and consumption of the data at the user's own pace.
            </p>

          </div>
          <div className="work__info wideColumn">
            <img src={Demo2} loading="lazy" alt="Demo of scrolling experience."></img>

          </div>
        </div>
        <div className="work">
          <div className="work__info wideColumn">
            <img src={Demo1} loading="lazy" alt="Demo of scrolling experience."></img>

          </div>
          <div className="work__info narrowColumn">
            <p>
              An animated data visualization also overlay conveys the altitude as the user scrolls “upwards”, as well as
              a HUD of vital signs indicating pulmonary function and blood gases.
            </p>

          </div>

        </div>

        <div className="work">

          <div className="work__info narrowColumn">
            <p>
             Users can also click on hotspots at each camp to read more information, as well as hovering for tooltips.
            </p>

          </div>
          <div className="work__info wideColumn">
            <img src={Demo3} loading="lazy" alt="Demo of scrolling experience."></img>

          </div>
        </div>

        
        <div className="work">



          <div className="work__info narrowColumn">
            <h4>TESTING</h4>
  
          </div>

        </div>

        <div className="work">

          <div className="work__info twoColumn">
            <p>I conducted five remote sessions of usability testing with users who had never used the website, using
              both quantatative and qualitative evalutions. Qualitative evaluations involved users' task success rate
              and time to task completion, while qualitative evaluation analyzed users' comments and thoughts for key
              themes.</p>
            <ul>
              <li>

                <p>All users responded <b>very positively to the graphic and interface design</b>,
                  particularly the microinteractions and colour palette. They also found the data
                  visualization of the blood gases very easy to interpret.</p>
              </li>
              <li>
                <p>The main <b>weaknesses were the salience of the camps</b>. Users who did not complete task 3
                  successfully attributed this to a lack of indication of when they had actually arrived at each
                  camp. </p>
              </li>
              <li>
                <p>Similarly, because of the exploratory nature, users did not read the information text in a
                  linear
                  fashion, resulting in <b>definitions and long forms of abbreviations being missed.</b>
                </p>
              </li>

            </ul>
            <img src={TaskSuccess} loading="lazy" alt="Table of task success rate."></img>
          </div>
          <div className="work__info twoColumn">

            <img src={TimeToTask} loading="lazy" alt="Table of task success rate."></img>
          </div>
        </div>

    
        

        <div className="work">
          <div className="work__info twoColumn">
            <h4> NEXT STEPS</h4>
            <p>*Update: many of these have since been implemented.</p>
          </div>

          <div className="work__info"  id="twoColumn">

            <ul>
              <li>
                <b>Clearer call to action</b>
                <p>
                  Many users missed the initial call to action at Base Camp, sometimes due to them navigating non-linearly, instead of going from Base Camp to the summit. Users also expressed that it could be more explicitly indicated when they had actually “arrived” at the camps. 
                </p>
              </li>
              <li>
                <b>Less passive onboarding</b>
                <p>
                  Two users kept on attempting to scroll upwards, despite already being at the top of the page. Future suggestions thus include making the onboarding modal more explicit, and require more complex user input to prevent mindless clicking. The instructions could remain accessible though a collapsed icon.
                </p>
              </li>
              <li>
                <b>Tooltips</b>
                <p>
                  Again due to the non-linear navigation that many users used, some found abbreviated terms (such as AMS) unclear, as they had focused on the camp information instead of the overall text on the right. A potential solution would be to implement tooltips for more technical terms.
                </p>
              </li>
            </ul>
          </div>

        </div>

        <ContactCTA />
      </div>
    </>
  );
}

export default DeathZone;
